import {IStaticDataRequestParams} from "../models/request/IStaticDataRequestParams"

export class StaticDataRequestParamsBuilder {

    staticDataRequestParams: IStaticDataRequestParams;

    constructor() {
        this.staticDataRequestParams = {
            vitalRequired: false,
            systematicExaminationRequired: false,
            generalExaminationRequired: false,
            habitRequired: false,
            comorbidConditionRequired: false,
            consultationTypeRequired: false,
            doctorTypeCodeRequired: false,
            medicineTypeRequired: false
        }
    }

    setVitalRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.vitalRequired = true;
        return this;
    }

    setSystematicExaminationRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.systematicExaminationRequired = true;
        return this;
    }

    setGeneralExaminationRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.generalExaminationRequired = true;
        return this;
    }

    setHabitRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.habitRequired = true;
        return this;
    }

    setComorbidConditionRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.comorbidConditionRequired = true;
        return this;
    }

    setConsultationTypeRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.consultationTypeRequired = true;
        return this;
    }

    setDoctorSpecialityCodeRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.doctorTypeCodeRequired = true;
        return this;
    }

    setMedicineTypeRequired(): StaticDataRequestParamsBuilder {
        this.staticDataRequestParams.medicineTypeRequired = true;
        return this;
    }

    build(): IStaticDataRequestParams {
        return this.staticDataRequestParams;
    }
}